import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import * as utils from 'automation-ui-canvas/flow/records/Flow/flowUtils';
export { utils };
export default Flow;